import React, { useState } from "react";
import { Box, Button, Stack, TextField, InputLabel } from "@mui/material";
import AvatarDropzone from "../StyledComponents/AvatarDropzone/AvatarDropzone";
import { addOrUpdateGuest } from "../../Requests/GuestService.ts";
import { Guest } from "../../Models/Guest.ts";
import HtmlEditor from '../HtmlEditorView/HtmlEditor.jsx';


export default function GuestsAdd(props: any) {

  const [avatar, setAvatar] = useState<string | undefined>("")
  const [firstName, setFirstName] = useState<string | undefined>("")
  const [lastName, setLastName] = useState<string | undefined>("")
  const [bio, setBio] = useState<string | undefined>("")
  const [occupation, setOccupation] = useState<string | undefined>("")

  const handlePublish = async (): Promise<void> => {
    let object = new Guest()
    object.firstName = firstName
    object.lastName = lastName
    object.bio = bio
    object.hidden = false
    object.occupation = occupation
    await addOrUpdateGuest(object, avatar)
    props.publish()
  }

  return (
    <Box sx={{ p: 3 }}>
      <Box>
        <AvatarDropzone
          title={"Guest Avatar"}
          callbackFile={(file) => { setAvatar(file) }}
        />

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"First Name"}</InputLabel>
          <TextField
            placeholder="First Name"
            value={firstName}
            onChange={(event) => setFirstName(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Last Name"}</InputLabel>
          <TextField
            placeholder="Last Name"
            value={lastName}
            onChange={(event) => setLastName(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Occupation"}</InputLabel>
          <TextField
            placeholder="Occupation"
            value={occupation}
            onChange={(event) => setOccupation(event.target.value)}
          />
        </Stack>

        <Stack
          spacing={1}
          marginTop={4}
        >
          <InputLabel>{"Bio"}</InputLabel>
          <HtmlEditor initialValue={bio} onChange={setBio} />
        </Stack>
      </Box>

      <Box
        display="flex"
        justifyContent="right"
        marginTop={4}
      >
        <Button
          variant="contained"
          size="large"
          onClick={() => handlePublish()}
        >
          {"Publish"}
        </Button>
      </Box>
    </Box>
  )
}
